import { types as t } from 'mobx-state-tree'
import { YEARS_EXTENT } from '../../../lib/constants'

export const YearsModel = t
  .model('YearsModel', {
    selectedYear: YEARS_EXTENT[1],
    isAnimationRunning: true,
    hoveredYear: t.maybeNull(t.number),
  })
  .views((self) => ({}))
  .actions((self) => ({
    setSelectedYear(year: number) {
      self.selectedYear = year
    },
    setHoveredYear(year: number) {
      self.hoveredYear = year
    },
    setIsAnimationRunning(isAnimationRunning: boolean) {
      self.isAnimationRunning = isAnimationRunning
    },
  }))
